import * as qs from "query-string";
import * as React from "react";
import { connect } from "react-redux";
import * as actions from "../../auth/actions";
import { IAuthState } from "../../auth/model";
import { AppState } from "../../root/rootReducer";
import { IntegrationsMessages, WelcomeText } from "./constants";

type WelcomeProps = {
    auth?: IAuthState,
    location: Location,
    login: (returnUrl: string) => void,
}

type WelcomeState = {
    appIdentifier: string,
}

class Welcome extends React.Component<WelcomeProps, WelcomeState> {

    constructor(props: WelcomeProps) {
        super(props)
        const { location } = this.props;
        const keys = qs.parse(location.search);
        const appIdentifier = keys.app as string;
        this.state = {
            appIdentifier,
        }
    }

    login = () => {
        const { login, location } = this.props;
        login(`choose_profile${location.search}`);
    }

    render() {
        const message = IntegrationsMessages[this.state.appIdentifier] || IntegrationsMessages.unsupported;

        return (
            <div className="Account">
                <div className="logged-out">
                    <div>
                        <img src="img/deako-logo.png" alt="logo" />
                        <p>{message}</p>
                        <button type="button" className="btn" onClick={this.login}>
                            {WelcomeText.login}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: AppState): WelcomeProps {
    return {
        auth: state.auth,
        location: window.location,
        login: (redirectUrl: string) => { throw new Error("login func was supposed to be overwritten by mapDispatch"); }
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        login: (redirectUrl: string) => actions.login(dispatch, redirectUrl),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Welcome);
